import { ResourceType } from '@components/resources/users/table/types';
import { useQueryParams } from '@hooks/queryParams';
import { resourcesRoute } from '@utils/consts';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useResourceType = () => {
  const [value, setValue] = useState<ResourceType>('office');
  const { pathname } = useLocation();

  const {
    params: { tab },
  } = useQueryParams();

  useEffect(() => {
    if (pathname.includes(resourcesRoute.equipment)) {
      setValue('equipment');
    } else if (pathname.includes(resourcesRoute.fieldWorkers)) {
      setValue((tab || 'fieldUser') as ResourceType);
    } else setValue('office');
  }, [pathname, tab]);

  return value;
};

export const getActive = (status: string[]) => {
  if (status?.length === 2) return;
  if (status?.includes('deactivated')) return false;
  return true;
};
